import {
  GET_LIST_CONGNOTHANHLY,
  GET_LIST_CONGNOTHANHLY_SUCCESS,
  GET_LIST_CONGNOTHANHLY_FAILURE,
  UPDATE_SEARCHTDATA_CONGNOTHANHLY,
} from "./actionTypes";

export const getListCongNoThanhLy = (dataSearch) => ({
  type: GET_LIST_CONGNOTHANHLY,
  dataSearch,
});
export const getListCongNoThanhLySuccess = (data) => ({
  type: GET_LIST_CONGNOTHANHLY_SUCCESS,
  payload: data,
});
export const getListCongNoThanhLyFailure = (dataSearch) => ({
  type: GET_LIST_CONGNOTHANHLY_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_CONGNOTHANHLY,
  payload: data,
});
